"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserHasReachedMaximumNumberOfActiveClasses extends client_library_1.ExtendableError {
    constructor() {
        super('You have reached the limit for the number of created & joined classes');
    }
}
exports.default = UserHasReachedMaximumNumberOfActiveClasses;
//# sourceMappingURL=UserHasReachedMaximumNumberOfActiveClasses.js.map